<template>
  <div id='contract-tab'>
    <div class='tabs'>
      <div class="d-flex justify-content-around">
        <div
          class="tab"
          :class="{ active: tab === cacheValue, disabled: (index < 1) }"
          :key="index"
          v-for="(tab, index) in tabs"
          @click="clickTab(tab)"
        >
          {{ $t(tab) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import TAB_NAMES from '../TabComponents/tabs';

export default {
  name: 'contract-tab',
  props: {
    value: {
      type: String,
      default: 'NOTES'
    },
  },
  setup(props, { emit }) {
    const tabs = ref(Object.keys(TAB_NAMES));

    const cacheValue = ref(props.value);

    const clickTab = (value) => { cacheValue.value = value; };

    watch(cacheValue, () => emit('input', cacheValue.value));

    return {
      tabs,
      cacheValue,
      clickTab,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#contract-tab {

  .tabs {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: $iron;

    .tab {
      text-transform: uppercase;
      font-weight: bold;
      cursor: pointer;
      font-size: 14px;
      color: $independence;
      padding: 20px 15px;
      transition: all .2s ease-in-out;

      &.active {
        color: $paradisePink;
      }

      &.disabled {
        color: $lavenderGrey;
        pointer-events: none;
      }
    }
  }
}
</style>
